<template>
  <div>
    <KitTabsContainer />

    <portal to="breadcrumbs-append">
      <div class="kit-details-tags e-flex e-items-center">
        |
        <span class="mx-2"></span>
        <TagSelector
          :tags="tagStore.tags"
          :selected-tags="kitSummaryStore.kit?.tags"
          :class="{ 'kit-details-tags--empty': !hasTags }"
          tooltip
          :show-add-button="!hasTags"
          open-on-selected-tag-click
          @tag-click="toggleTag"
        >
          <template v-if="!hasTags" #add-btn>
            <v-btn x-small class="default-add-btn" depressed>
              Add tag
              <v-icon small>fa-plus</v-icon>
            </v-btn>
          </template>
        </TagSelector>
      </div>
    </portal>

    <portal to="breadcrumbs-right">
      <KitDeleteDialog v-if="canDeleteKits" />
    </portal>
  </div>
</template>

<script>
import KitTabsContainer from "@/components/kits/KitTabsContainer"
import { useKitSummaryStore } from "@/stores/kitSummary"
import { useBreadcrumbStore } from "@/stores/breadcrumb"
import { useTagStore } from "~/stores/tag"
import KitDeleteDialog from "@/components/kits/KitDeleteDialog.vue"
import { PERMISSIONS } from "@/constants/permissions"
import TagSelector from "~/components/tags/TagSelector.vue"
import { mapStores } from "pinia"

export default {
  components: {
    TagSelector,
    KitDeleteDialog,
    KitTabsContainer,
  },
  async asyncData({ params, from }) {
    const kitSummaryStore = useKitSummaryStore()
    await kitSummaryStore.loadKit(params.id)

    let kitsPageFullPath = kitSummaryStore.previousKitsPageFullPath

    if (from?.path !== "/kits" || !kitsPageFullPath) {
      kitsPageFullPath = "/kits"
    }

    const breadcrumbStore = useBreadcrumbStore()
    breadcrumbStore.breadcrumbs = [
      {
        name: "Home",
        href: "/",
        icon: "fa-house",
      },
      {
        name: "Kits",
        href: kitsPageFullPath,
        icon: "fa-box",
      },
      {
        name: `${kitSummaryStore.kit?.name || ""} - (${
          kitSummaryStore.kit?.serial || ""
        })`,
      },
    ]

    return {
      kitId: params.id,
    }
  },
  head() {
    const KitSummaryStore = useKitSummaryStore()

    return {
      title: `${KitSummaryStore?.kit.name} - (${KitSummaryStore.kit?.serial})`,
    }
  },
  computed: {
    ...mapStores(useTagStore, useKitSummaryStore),
    canDeleteKits() {
      return this.$permissions.user.can(PERMISSIONS.KITS.DELETE)
    },
    hasTags() {
      return this.kitSummaryStore.kit?.tags?.length > 0
    },
  },
  async mounted() {
    await this.tagStore.fetchTags()
  },
  methods: {
    async toggleTag(tag) {
      await this.tagStore.toggleKitTag({
        tag,
        kit: this.kitSummaryStore.kit,
      })
    },
  },
}
</script>

<style lang="scss">
.kit-details-tags {
  .tags__selected-items .tag {
    margin-right: 0.25rem;
    margin-top: 1px;
  }
  &--empty {
    .tags__add-btn {
      display: block !important;
      i {
        margin-top: 2px;
        margin-left: 4px;
      }
    }
  }
}
</style>
